import router from '../services/router_service';
import personController from '../controllers/person_controller';

router.on('route:person', personController);
